import { isBrowser } from './is-browser';

export function getAppLink(): string {
  const userAgent = isBrowser() ? navigator.userAgent : '';
  const isIOS = /iPhone|iPad|Macintosh/.test(userAgent);

  if (isIOS) {
    return 'https://apps.apple.com/de/app/akam-onlayn-testlar/id1619248324';
  }

  return 'https://play.google.com/store/apps/details?id=com.test.aim.uz';
}
